<template>

  <div>
    <div class="hflex p-4">
      <div
        v-if="profile.photo_media_url"
        class="mr-3">
        <img
          :src="profile.photo_media_url"
          :alt="profile.name"
          class="img-fluid rounded mb-3"
          style="max-width: 120px;"
        />
      </div>
      <div>
        <h3 class="mb-1">{{ profile.name }}</h3>
        <p class="text-muted mb-2">{{ profile.position }}</p>

        <p class="mb-1" v-if="profile.company && profile.company.name">
          <strong>Empresa:</strong> {{ profile.company.name }}
        </p>

        <p class="mb-1" v-if="profile.location">
          <strong>Localização:</strong> {{ profile.location }}
        </p>

        <div class="mt-4">
          <a
            v-if="profile.profile_url"
            :href="profile.profile_url"
            target="_blank"
            rel="noopener noreferrer"
            class="btn btn-link"
          >
            <i class="fab fa-linkedin mr-1"></i>
            LinkedIn
          </a>
          <button
            v-if="loading"
            class="btn btn-link"
            disabled>
            <div class="spinner-border" style="width: 1.2rem; height: 1.2rem;"></div>
            Carregando...
          </button>
          <button
            v-if="!loading"
            @click="handleImport"
            class="btn btn-outline-secondary"
            :disabled="loading"
          >
            <i class="fa fa-file-alt mr-1"></i>
            Importar perfil
          </button>
          <RouterLink
            v-if="!loading && duplicateProfileId"
            class="btn btn-link"
            :to="`/job/${job._id}/seeker/${this.profile._id}?candidate_id=${duplicateProfileId}`">
            <i class="fa-solid fa-arrow-up-right-from-square"></i>
          </RouterLink>
        </div>
      </div>
    </div>
    <hr class="m-0">
    <div class="p-4">
      <h5 class="mb-4">Resumo profissional</h5>
      <p class="m-0">{{ profile.description }}</p>
    </div>
    <hr class="m-0">
    <div
      v-if="profile.evaluations && profile.evaluations.length"
      class="p-4">
      <h5 class="mb-4">Critérios resolvidos</h5>
      <div class="d-flex flex-column" style="gap: 20px;">
        <div
          v-for="(item, index) in profile.evaluations"
          :key="index"
          class="hflex"
        >
          <div class="mr-3 mt-1">
            <div class="alert alert-success px-2 py-1">
              <i class="fa fa-check text-success" />
            </div>
          </div>

          <div>
            <h6 class="mb-1">{{ item.criterion }}</h6>
            <p class="mt-2 mb-0 text-muted">{{ item.reasoning }}</p>

            <!-- References -->
            <div
              v-if="item.references && item.references.length"
              class="mt-2">
              <a
                class="btn btn-link p-0"
                data-toggle="collapse"
                :href="'#refs-' + index"
              >
                Ver referências
              </a>
              <div class="collapse mt-2" :id="'refs-' + index">
                <ul class="list-group m-0">
                  <li
                    v-for="(ref, i) in item.references"
                    :key="i"
                    class="list-group-item"
                  >
                    <div><strong>{{ ref.title || 'Referência' }}</strong></div>
                    <p class="mb-1 small text-muted" v-if="ref.snippet">{{ ref.snippet }}</p>
                    <a
                      :href="ref.url"
                      target="_blank"
                      rel="noopener noreferrer"
                      class="small"
                    >
                      {{ ref.url }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <hr class="m-0">
    <div
      v-if="profile.work_history && profile.work_history.length"
      class="p-4">
      <h5 class="mb-4">Experiência profissional</h5>
      <div class="d-flex flex-column" style="gap: 20px;">
        <div
          v-for="(job, index) in profile.work_history"
          :key="index"
        >
          <div class="hflex">
            <div class="hflex-col-1">
              <small>{{ job.date_from }} - {{ job.date_to }}</small>
            </div>
            <div class="hflex-col-3">
              <h6 class="mb-1">
                {{ job.title || 'Cargo não informado' }}
              </h6>
              <div>
                <div class="text-muted">
                  {{ job.company && job.company.name ? job.company.name : 'Empresa não informada' }}
                </div>
                <div v-if="job.location">{{ job.location }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr class="m-0">
    <div
      v-if="profile.education_history && profile.education_history.length"
      class="p-4">
      <h5 class="mb-4">Formação acadêmica</h5>
      <div class="d-flex flex-column" style="gap: 20px;">
        <div
          v-for="(education, index) in profile.education_history"
          :key="index"
        >
          <div class="hflex">
            <div class="hflex-col-1">
              <small>{{ education.date_from }} - {{ education.date_to }}</small>
            </div>
            <div class="hflex-col-3">
              <h6 class="mb-1">
                {{ education.degree || 'Formação não informada' }}
              </h6>
              <p class="mb-1 text-muted">
                {{
                  education.institution && education.institution.name
                    ? education.institution.name
                    : 'Instituição não informada'
                }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-3"></div>
  </div>

</template>

<script>
export default {
  name: 'JobSeekerProfile',
  components: {
  },
  props: {
    profile: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      loading: true,
      value: null
    }
  },
  computed: {
    job () {
      return this.$store.getters.getJob
    },
    duplicateProfileId () {
      if (this.value && this.value.candidate_duplicates && this.value.candidate_duplicates.length) {
        // retorna o ultimo duplicateProfileId
        return this.value.candidate_duplicates[this.value.candidate_duplicates.length - 1]._id
      }
      return null
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    async loadData () {
      this.loading = true
      try {
        const { data } = await this.axios.get(`/accounts/${this.$store.getters.getAccount._id}/jobs/${this.job._id}/seeker/profiles/${this.profile._id}`)
        this.value = data
      } catch (err) {
        console.log(err)
      } finally {
        this.loading = false
      }
    },
    async handleImport () {
      this.loading = true
      try {
        const { data } = await this.axios.post(`/accounts/${this.$store.getters.getAccount._id}/jobs/${this.job._id}/seeker/profiles/${this.profile._id}/import`, {})
        this.value = data
      } catch (err) {
        console.log(err)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Job/JobSeeker/JobSeekerProfile.vue